import officerImage from '../../assets/imgs/management/MD.jpg';

export default function MDBio (props) {

    return (
        <div className="bio-container">
            <div className="bio-card">
                <div className="bio-image">
                <img src={officerImage} alt="Officer Name" />
                </div>
                <div className="bio-content">
                    <h2>Francis Kahuha</h2>
                    <h3>Managing Director</h3>
                    <hr />
                    <div className="bio-details">
                        <p>Francis Kahuha, PhD; MSc (Earth & Climate Science), University of Nairobi; BSc. IBA, Trade & Economics (USIU–Africa)</p>
                        {/* <h4>Education</h4>
                        <ul>
                            <li>PhD. in Environmental Governance and Management - University of Nairobi</li>
                            <li>MSc in Environmental Governance - University of Nairobi</li>
                            <li>BSc in International Business Administration - United States International University- Africa.</li>
                        </ul> */}
                    </div>
                    <p>
                        Francis Kahuha is the Managing Director of Githunguri Water & Sanitation Company Ltd, where he provides strategic leadership 
                        in securing reliable water supply, strengthening water resource governance, and modernizing wastewater infrastructure for 
                        rapidly growing communities. He oversees the implementation of the KSh 21 billion Thika and Githunguri Water and Sanitation 
                        Improvement Project financed by Impact Fund Denmark (IFDK), one of the most transformative water security investments in 
                        Kiambu County. His leadership philosophy is anchored in evidence-based planning, operational excellence, inclusive governance, 
                        and a deep commitment to public service.
                    </p>
                    <p>
                        Alongside his executive role, Francis is a Doctor of Philosophy researcher in Earth Sciences at the University of Nairobi’s 
                        Department of Earth and Climate Sciences. His academic work spans the interdisciplinary domains of water economics, environmental 
                        law and policy, ecosystem management, and Earth system science. He examines how hydrological processes interact with economic incentives, 
                        governance structures, and ecological thresholds to shape water security and wastewater management outcomes. Inspired by the work of 
                        Swedish Earth system scientist Johan Rockström on planetary boundaries and economist Kate Raworth’s “Doughnut Economics” framework, he 
                        integrates scientific evidence, economic reasoning and sustainability principles to advance equitable, climate-resilient water governance.
                    </p>
                    <p>
                        Francis has contributed to the Education for Sustainable Development in Africa (ESDA II) research initiative at the University of 
                        Nairobi under the guidance of former Vice-Chancellor Prof. Peter Mbithi, supporting the integration of sustainability science into 
                        higher-education and community resilience frameworks. He is a certified Monitoring, Evaluation and Learning (MEL) expert and a NEMA-licensed 
                        Associate Expert in Environmental Impact Assessment and Audit (EIA/EA). His Certificate in Sustainable Land Use Management (SLUSE) 
                        from the University of Copenhagen was completed under the guidance of Prof. Christian P. Hansen of the Department of Food and Resource 
                        Economics, while his international research experience also includes participation in the Supporting Holistic and Actionable Research in 
                        Education (SHARe) initiative guided by Prof. Tom Purekal of the University of Notre Dame. 
                    </p>
                    <p>
                        His wider scientific engagements span global warming dynamics, cryosphere processes, decarbonization pathways, hydrometeorological 
                        extremes, climate modelling, cloud microphysics, and major climate oscillations such as ENSO, NAO, and PDO. Extensive travel across 
                        diverse ecological zones from polar environments to tropical rainforests has enriched his understanding of Earth system processes 
                        and their implications for ecosystems, sustainable development, and human wellbeing.
                    </p>
                    <p>
                        Francis has also collaborated internationally with CIFOR on forestry–food system linkages and is increasingly active in emerging global 
                        conversations on carbon projects, carbon markets and green transitions, particularly where they intersect with community livelihoods, 
                        climate adaptation, and resilient water systems. A reflective and analytically driven scholar-practitioner, he believes that rigorous 
                        inquiry, inclusive governance, and integrated science–policy approaches are essential to achieving transformative and sustainable 
                        development especially in the water sector, where environmental systems and human wellbeing converge most directly.
                    </p>
                    <hr />
                    {/* <div className="bio-details">
                        <h4>Achievements</h4>
                        <ul>
                        <li>Transformed the company to achieve 30% increase in efficiency.</li>
                        <li>Successfully led the implementation of the climate adaptation strategy.</li>
                        <li>Recognized for excellent customer service initiatives.</li>
                        </ul>
                        <h4>Contact</h4>
                        <ul>
                        <li>Email: johndoe@company.com</li>
                        <li>LinkedIn: linkedin.com/in/johndoe</li>
                        </ul>
                    </div> */}
                </div>
            </div>
        </div>     
    );

    
}